module.exports = __webpack_public_path__ + "static/img/anxunMobel22.785fb7ae.png";